module.exports = __webpack_public_path__ + "static/logo-a30034f7382b8a4ca8872e3d9a766789.svg";